import { useEffect } from "react";
import { MetricName } from "@constants/logging";
import { useGetLogger } from "@hooks/useGetLogger";

// TODO [LOWA-30534] From: https://tiny.amazon.com/1fs0z8wj7
export const useTrackPageRefreshEvent = () => {
    const log = useGetLogger();

    useEffect(() => {
        log.publishCounterMetric(MetricName.REFRESH);

        /*
          Track page refresh events using an experimental api, this is not supported in
          iE or safari. The alternative to listen to page refresh page events will never work
          because the publish fn is async and batched so it will not finish before the browser
          kills the thread.
        */
        if (performance.getEntriesByType) {
            const perfEntries = performance.getEntriesByType("navigation");
            // eslint-disable-next-line
            // @ts-ignore spec is here https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming/type
            if (perfEntries[0] && perfEntries[0].type === "reload") {
                log.publishCounterMetric(MetricName.CLICK);
            }
        }
    }, []);
};
